/* eslint-env browser, jquery */
/* globals Backbone */

'use strict';

const GoodsWarrantyView = require('./views/goods_warranty');

const GoodsWarranty = {
  init({ buyButton, goodsWarranty }, done) {
    if (!goodsWarranty) {
      done();
      return;
    }

    const model = new Backbone.Model({
      bundleCheckoutUrl: goodsWarranty.bundleCheckoutUrl,
      buyUrl: (buyButton && buyButton.buyButtonUrl) || undefined,
    });
    new GoodsWarrantyView({
      model,
      goodsWarranty,
    });
    done();
  },
};

module.exports = GoodsWarranty;
